// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  env: 'QA',
  appName: 'Spotlight',
  uiRedirectUrl: 'https://qa.spotlight.cfahome.com/login/callback', // QA UI URL
  oktaClientId: '0oa1elkry0tMPlkK40h8',
  oktaAuthUrl: 'https://cfahome.oktapreview.com', // Development Okta Auth URL
  oktaAuthIssuer: 'https://cfahome.oktapreview.com/oauth2/auscjsakz3PaAP82K0h7',
  endSessionRedirectUri: 'https://qa.spotlight.cfahome.com/logged-out',
  spotlightApiUrl: 'https://spotlight.dxe.qa.crndev.chick-fil-a.com',
  eventMetricsUrl: 'https://qa.spotlight.cfahome.com',
  digitalMarketingCampaignsServiceURL:  'https://test.spotlight.api.chick-fil-a.com/digital-marketing',
  digitalMarketingAudienceServiceURL:  'https://test.spotlight.api.chick-fil-a.com/audience',
  d2cUrl: 'https://d2c.api.qa.crndev.chick-fil-a.com',
  urlsForAuthHeader: [
    'https://spotlight.dxe.qa.crndev.chick-fil-a.com',
    'https://test.spotlight.api.chick-fil-a.com',
    'https://qa.spotlight.cfahome.com'
  ],
  urlsForJWTHeader: [
    'https://d2c.api.qa.crndev.chick-fil-a.com',
  ],
  launchDarklyClientId: '64dd3ca2a99b9d138da58ad7',
  amplitudeApiKey: '4d0efb265bfcf55caeebab42990b39b4',
  pendoApiKey: '34a036c2-887a-4887-a841-8f3263d572e5'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
